import React from "react";
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" style={{
    paddingBottom: "10px"
  }} data-id="element-150" data-mp="1qalq4w8vplqd">
      <div className="container mx-auto px-4 md:px-6 max-w-[1120px]" data-id="element-151" data-mp="1o2vjmvsbez9q">
        <div className="max-w-3xl mx-auto bg-[#F5F7F9] rounded-[20px] p-8 md:p-12 border border-gray-200 text-center flex flex-col items-center shadow-sm" data-id="element-152" data-mp="223oejhmj3wdd">
          <div className="w-32 h-32 md:w-40 md:h-40 mb-6 flex items-center justify-center" data-id="element-153" data-mp="1x28vtw7tq1y5">
            <img src="https://cdn.magicpatterns.com/uploads/2UHRAj28DSqQGHLVZADGT6/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png" alt="Sello de Garantía de 7 Días" className="w-full h-full object-contain drop-shadow-xl hover:scale-105 transition-transform duration-300" data-id="element-154" data-mp="19co8l14n0ij2" />
          </div>
          
          <h2 className="text-[24px] md:text-[32px] font-[900] text-[#07152D] mb-4 tracking-[-0.5px]" data-id="element-155" data-mp="1ec0sbd07p9hf">
            RIESGO CERO: GARANTÍA
          </h2>
          
          <p className="text-[15px] md:text-[17px] text-gray-600 leading-[1.5] max-w-2xl mb-8" data-id="element-156" data-mp="lodag5qbswyh">
            Accedé al contenido y evaluá el material. Si la compra cuenta con garantía, podrás solicitarla dentro del período de 7 días informado en las condiciones de compra.
          </p>

          
        </div>
      </div>
    </section>;
}